import { Plus, Upload, Filter, ChevronDown } from "lucide-react";
import { AppChrome } from "./DashboardMockup";

const filters = [
    ["All", "2,540", true],
    ["Hot", "86", false],
    ["Warm", "214", false],
    ["New", "430", false],
    ["Unassigned", "19", false],
];

const leads = [
    { name: "Ananya Iyer", company: "Northwind Realty", source: "Website", owner: "RS", score: 92, status: "Qualified", next: "Site visit · Today 3 PM" },
    { name: "Vikram Menon", company: "Orbit Staffing", source: "Google Ads", owner: "PN", score: 74, status: "Contacted", next: "Demo call · Tomorrow" },
    { name: "Rohan Kulkarni", company: "Meridian Estates", source: "IndiaMart", owner: "RS", score: 88, status: "Qualified", next: "Proposal review · Fri" },
    { name: "Sara D'Souza", company: "FinEdge Capital", source: "Referral", owner: "AT", score: 61, status: "New", next: "Intro WhatsApp · 4 PM" },
    { name: "Arjun Nair", company: "Skyline Group", source: "Website", owner: "PN", score: 83, status: "Contacted", next: "Follow-up call · 6 PM" },
    { name: "Divya Rao", company: "BrightHire HR", source: "LinkedIn", owner: "AT", score: 57, status: "New", next: "Qualify · Tomorrow" },
];

const statusStyle = {
    Qualified: "bg-[#F0FDF4] text-[#15803D] border-[#BBF7D0]",
    Contacted: "bg-blue-50 text-blue-600 border-blue-100",
    New: "bg-slate-50 text-slate-600 border-slate-200",
};

const LeadsScreen = () => (
    <div>
        <AppChrome active="Leads" />
        <div className="bg-[#F7F9FA] p-3.5 sm:p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                    <p className="font-display text-[15px] font-extrabold text-[#111827]">Leads</p>
                    <p className="text-[10px] text-[#64748B]">2,540 total · 430 new this month</p>
                </div>
                <div className="flex items-center gap-1.5">
                    <span className="flex items-center gap-1 rounded-lg border border-[#E5E7EB] bg-white px-2 py-1 text-[9px] font-semibold text-[#475569]">
                        <Filter className="h-2.5 w-2.5" /> Filters
                    </span>
                    <span className="hidden items-center gap-1 rounded-lg border border-[#E5E7EB] bg-white px-2 py-1 text-[9px] font-semibold text-[#475569] sm:flex">
                        <Upload className="h-2.5 w-2.5" /> Import
                    </span>
                    <span className="flex items-center gap-1 rounded-lg bg-[#16A34A] px-2 py-1 text-[9px] font-bold text-white">
                        <Plus className="h-2.5 w-2.5" /> Add Lead
                    </span>
                </div>
            </div>

            <div className="mt-2.5 flex gap-1.5 overflow-x-auto [scrollbar-width:none]">
                {filters.map(([label, count, active]) => (
                    <span
                        key={label}
                        className={`flex shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-[9px] font-bold ${
                            active
                                ? "bg-[#16A34A] text-white"
                                : "border border-[#E5E7EB] bg-white text-[#64748B]"
                        }`}
                    >
                        {label}
                        <span className={active ? "text-white/80" : "text-[#94A3B8]"}>{count}</span>
                    </span>
                ))}
            </div>

            <div className="mt-2.5 overflow-hidden rounded-xl border border-[#EDF0F3] bg-white shadow-sm">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-[620px] text-left">
                        <thead>
                            <tr className="border-b border-[#F1F5F9] bg-[#FBFDFC] text-[8px] font-bold uppercase tracking-[0.1em] text-[#94A3B8]">
                                <th className="px-3 py-2">Lead</th>
                                <th className="px-2 py-2">Company</th>
                                <th className="px-2 py-2">Source</th>
                                <th className="px-2 py-2">Owner</th>
                                <th className="px-2 py-2">Score</th>
                                <th className="px-2 py-2">Status</th>
                                <th className="px-3 py-2">Next Activity <ChevronDown className="inline h-2 w-2" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {leads.map((l) => (
                                <tr key={l.name} className="border-b border-[#F8FAFC] last:border-0 hover:bg-[#F7FEF9]">
                                    <td className="px-3 py-2">
                                        <span className="flex items-center gap-2">
                                            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#111827] text-[7px] font-bold text-white">
                                                {l.name.split(" ").map((n) => n[0]).join("")}
                                            </span>
                                            <span className="text-[10px] font-semibold text-[#111827]">{l.name}</span>
                                        </span>
                                    </td>
                                    <td className="px-2 py-2 text-[9px] font-medium text-[#64748B]">{l.company}</td>
                                    <td className="px-2 py-2 text-[9px] font-medium text-[#64748B]">{l.source}</td>
                                    <td className="px-2 py-2">
                                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#F0FDF4] text-[7px] font-bold text-[#15803D]">{l.owner}</span>
                                    </td>
                                    <td className="px-2 py-2">
                                        <span className="flex items-center gap-1">
                                            <span className="h-1 w-8 rounded-full bg-[#F1F5F9]">
                                                <span className="block h-1 rounded-full bg-[#16A34A]" style={{ width: `${l.score}%` }} />
                                            </span>
                                            <span className="text-[8px] font-bold text-[#111827]">{l.score}</span>
                                        </span>
                                    </td>
                                    <td className="px-2 py-2">
                                        <span className={`rounded-full border px-1.5 py-0.5 text-[7px] font-bold ${statusStyle[l.status]}`}>{l.status}</span>
                                    </td>
                                    <td className="px-3 py-2 text-[9px] font-medium text-[#334155]">{l.next}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
);

export default LeadsScreen;
